/**
 * Created by shanie on 11/3/16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { EditDescription } from './EditDescription';
import { EditTitle } from './EditTitle';
import IconButton from '../Toolbar/IconButton';
import MinusIcon from 'dibs-vg/dist/react/minus';
import PenIcon from 'dibs-vg/dist/react/pen';
import PlusIcon from 'dibs-vg/dist/react/plus';
import RemoveIcon from 'dibs-vg/dist/react/trash-can';
import ShareIcon from 'dibs-vg/dist/react/share';
import SwitchButton from '../Toolbar/SwitchButton';
import Tooltip from '../Tooltip';

// Helpers
import classnames from 'classnames';
import actions from '../../actions/FavoritesActions';
import { copy, deviceTypes, cutoffs, privacySettings, tabs, tooltips } from '../../constants';

// Styles
import styles from './styles/EditInlineHeader.scss';

// Tracking
import { trackEvent } from 'dibs-tracking';

class EditInlineHeader extends React.Component {
    constructor(props) {
        super(props);

        this.description = this.props.description.trim() || copy.addDescription.PLACEHOLDER;
        this.title = this.props.title;

        this.state = { expanded: false, hoveringShare: false };
        this.editFolder = this.editFolder.bind(this);
        this.editPrivacy = this.editPrivacy.bind(this);
        this.onShare = this.onShare.bind(this);
        this.renderFolderActionComponent = this.renderFolderActionComponent.bind(this);
        this.setEditFolder = this.setEditFolder.bind(this);
    }

    componentWillMount() {
        this.props.setPortfolioDescription(this.props.description || '');
        this.props.setNewPortfolioName(this.title);
    }

    componentDidMount() {
        window.addEventListener('click', this.editFolder);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.title !== nextProps.title) {
            this.title = nextProps.title;
            this.props.setNewPortfolioName(this.title);
        }

        if (this.props.description !== nextProps.description) {
            this.description = nextProps.description.trim();
            this.props.setPortfolioDescription(this.description);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.editFolder);
    }

    editFolder() {
        if (this.props.editFolder) {
            this.description =
                this.props.newPortfolioDescription.trim() || copy.addDescription.PLACEHOLDER;
            const { newPortfolioDescription, newPortfolioName, title } = this.props;
            if (this.props.newPortfolioName === '') {
                this.props.setNewPortfolioName(title);
                this.props.onEditFolder({
                    action: 'EDIT',
                    description: newPortfolioDescription,
                    name: title,
                });
            } else {
                this.title = this.props.newPortfolioName;
                this.props.onEditFolder({
                    action: 'EDIT',
                    description: newPortfolioDescription,
                    name: newPortfolioName,
                });
            }
            this.props.setEditFolder(false);
        }
    }

    editPrivacy() {
        if (this.props.newPortfolioPrivacy === privacySettings.PUBLIC) {
            this.props.setPortfolioPrivacy(privacySettings.PRIVATE);
            this.props.onEditPrivacy({ action: 'EDIT', privacyLevel: privacySettings.PRIVATE });
        } else {
            this.props.setPortfolioPrivacy(privacySettings.PUBLIC);
            this.props.onEditPrivacy({ action: 'EDIT', privacyLevel: privacySettings.PUBLIC });
        }
    }

    onShare() {
        trackEvent({
            action: 'email a friend initiated',
            label: 'folder',
            category: 'email a friend',
        });

        this.props.onShare();
    }

    renderFolderActionComponent() {
        const { tab } = this.props;
        const isMobile = this.props.deviceType === deviceTypes.MOBILE;
        const isTablet = this.props.deviceType === deviceTypes.TABLET;
        const folderActionClasses = classnames(styles.folderActionContainer, {
            [styles.folderActionMobile]: isMobile,
        });
        const switchClasses = classnames(styles.shareSwitch, { [styles.switchMobile]: isMobile });
        const shareClasses = classnames(styles.shareActions, { [styles.shareMobile]: isMobile });
        return (
            <div className={folderActionClasses}>
                {tab !== tabs.PROJECT && (
                    <IconButton
                        dataTn="remove-folder"
                        IconComponent={RemoveIcon}
                        buttonText="delete"
                        isMobile={isMobile}
                        isTablet={isTablet}
                        onClick={this.props.onRemoveFolder}
                        upperCase={false}
                    />
                )}
                {this.props.totalResults === 0 ? null : (
                    <div className={shareClasses}>
                        <div
                            className={styles.tooltip}
                            onMouseEnter={() => this.setState({ hoveringShare: true })}
                            onMouseLeave={() => this.setState({ hoveringShare: false })}
                        >
                            <div className={styles.shareFolder}>
                                <IconButton
                                    dataTn="share-folder"
                                    disabled={
                                        this.props.newPortfolioPrivacy === privacySettings.PRIVATE
                                    }
                                    IconComponent={ShareIcon}
                                    buttonText={
                                        isMobile
                                            ? copy.bulkActions.SHARE_MOBILE
                                            : copy.bulkActions.SHARE
                                    }
                                    onClick={this.onShare}
                                    isMobile={isMobile}
                                    isTablet={isTablet}
                                    upperCase={false}
                                />
                            </div>
                            {!isMobile ? (
                                <Tooltip
                                    copy={copy.tooltips.SHARE_FOLDER}
                                    hovering={
                                        this.state.hoveringShare &&
                                        this.props.newPortfolioPrivacy === privacySettings.PRIVATE
                                    }
                                    showOnHover
                                    type={tooltips.SHARE_FOLDER}
                                />
                            ) : null}
                        </div>
                        {tab !== tabs.PROJECT && (
                            <SwitchButton
                                containerClass={switchClasses}
                                dataTn="make-shareable-toggle"
                                offText="No"
                                onSwitch={this.editPrivacy}
                                onText="Yes"
                                switchLabel={copy.createFolder.SWITCH_LABEL}
                                switchOn={this.props.newPortfolioPrivacy === privacySettings.PUBLIC}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }

    setEditFolder(e) {
        e.stopPropagation();
        if (!this.props.isPublic && this.props.deviceType !== deviceTypes.MOBILE) {
            this.props.setEditFolder(true);
        }
    }

    render() {
        const { deviceType, editFolder, isPublic, selecting, tab, isLoadingFullPage } = this.props;
        const isMobile = deviceType === deviceTypes.MOBILE;
        const isProject = tab === tabs.PROJECT;
        const hideEditFolderIcon = isProject || isPublic || isMobile || selecting;
        // do not allow the edit description box on project tab
        // do not allow if it is in a public view
        // do not allow on mobile
        // do not allow if the description is the same as the default placeholder copy
        const hideEditDescription =
            isProject ||
            (this.description === copy.addDescription.PLACEHOLDER && (isPublic || isMobile));

        const descriptionClasses = classnames(styles.descriptionContainer, {
            [styles.descriptionEditable]: !isMobile && !selecting,
            [styles.edit]: editFolder,
        });

        const titleWrapperClasses = classnames(styles.top, { [styles.mobileTitle]: isMobile });

        const titleClasses = classnames(styles.titleContainer, {
            [styles.titleEditable]: !isMobile && !selecting,
            [styles.edit]: editFolder,
        });

        const titleIconClasses = classnames(styles.icon, {
            [styles.editIcon]: editFolder,
        });

        const containerClass = tab === tabs.PROJECT ? styles.containerProject : styles.container;

        return (
            <div className={containerClass}>
                {isPublic || this.props.totalResults === 0 || !isMobile ? null : (
                    <div className={styles.mobileTop}>{this.renderFolderActionComponent()}</div>
                )}
                <div className={titleWrapperClasses}>
                    <div
                        className={titleClasses}
                        data-tn="folder-name"
                        onClick={e => (!selecting ? this.setEditFolder(e) : null)}
                    >
                        {editFolder && !isPublic && !isProject ? (
                            <EditTitle
                                newPortfolioName={this.props.newPortfolioName}
                                setNewPortfolioName={this.props.setNewPortfolioName}
                            />
                        ) : (
                            this.title
                        )}
                        <span className={styles.count}>({this.props.totalResults})</span>
                        {hideEditFolderIcon || isLoadingFullPage ? null : (
                            <div className={styles.editFolder}>
                                <div className={titleIconClasses}>
                                    <PenIcon className={styles.pen} />
                                </div>
                                <Tooltip
                                    copy={copy.tooltips.EDIT_FOLDER}
                                    type={tooltips.EDIT_FOLDER}
                                />
                            </div>
                        )}
                    </div>
                    {isPublic || isMobile || selecting ? null : (
                        <div className={styles.right}>{this.renderFolderActionComponent()}</div>
                    )}
                </div>
                {hideEditDescription ? null : (
                    <div className={styles.inline}>
                        <div
                            className={descriptionClasses}
                            data-tn="folder-description"
                            onClick={e => (!selecting ? this.setEditFolder(e) : null)}
                        >
                            {editFolder ? (
                                <EditDescription
                                    newPortfolioDescription={this.props.newPortfolioDescription}
                                    setPortfolioDescription={this.props.setPortfolioDescription}
                                />
                            ) : (
                                <div className={styles.text}>
                                    <div className={styles.descriptionDesktop}>
                                        {this.description.length >
                                            cutoffs.MAX_CHAR_DESCRIPTION_MOBILE &&
                                        !this.state.expanded &&
                                        isMobile
                                            ? `${this.description.slice(
                                                  0,
                                                  cutoffs.MAX_CHAR_DESCRIPTION_MOBILE
                                              )}...`
                                            : this.description}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {this.description === copy.addDescription.PLACEHOLDER ||
                this.description.length < cutoffs.MAX_CHAR_DESCRIPTION_MOBILE ||
                editFolder ||
                !isMobile ? null : (
                    <div
                        className={styles.expand}
                        onClick={() => this.setState({ expanded: !this.state.expanded })}
                    >
                        {this.state.expanded ? (
                            <div className={styles.less}>
                                <MinusIcon className={styles.expandIcon} /> SEE LESS
                            </div>
                        ) : (
                            <div className={styles.more}>
                                <PlusIcon className={styles.expandIcon} /> SEE MORE
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

EditInlineHeader.propTypes = {
    deviceType: PropTypes.string,
    description: PropTypes.string,
    editFolder: PropTypes.bool,
    newPortfolioDescription: PropTypes.string,
    newPortfolioName: PropTypes.string,
    newPortfolioPrivacy: PropTypes.string,
    onEditFolder: PropTypes.func,
    onShare: PropTypes.func.isRequired,
    setEditFolder: PropTypes.func,
    onEditPrivacy: PropTypes.func,
    onRemoveFolder: PropTypes.func,
    selecting: PropTypes.bool,
    setPortfolioDescription: PropTypes.func,
    setNewPortfolioName: PropTypes.func,
    setPortfolioPrivacy: PropTypes.func,
    tab: PropTypes.string,
    title: PropTypes.string,
    totalResults: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isPublic: PropTypes.bool,
    isLoadingFullPage: PropTypes.bool,
};

const mapStateToProps = state => {
    return {
        deviceType: state.favorites.uiState.deviceType,
        editFolder: state.favorites.editInlineState.editFolder,
        newPortfolioDescription: state.favorites.creationState.newPortfolioDescription,
        newPortfolioName: state.favorites.creationState.newPortfolioName,
        newPortfolioPrivacy: state.favorites.creationState.newPortfolioPrivacy,
        tab: state.favorites.uiState.tab,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setEditFolder: editFolder => {
            dispatch(actions.setEditFolder({ editFolder }));
        },
        setPortfolioDescription: newPortfolioDescription => {
            dispatch(actions.setPortfolioDescription({ newPortfolioDescription }));
        },
        setNewPortfolioName: newPortfolioName => {
            dispatch(actions.setNewPortfolioName({ newPortfolioName }));
        },
        setPortfolioPrivacy: newPortfolioPrivacy => {
            dispatch(actions.setPortfolioPrivacy({ newPortfolioPrivacy }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditInlineHeader);
